import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import SydLabel from '../../../../../../../commonDesign/SydLabel'
import SydSelect from '../../../../../../../commonDesign/SydSelect'
import { getVariantOptions, getVariantParameters, getChartVariantOptions, getChartVariantParameters } from '../../../../../../../organisms/QueryBlueprint/styleVariants'
import VariantParamControls from './VariantParamControls'

function StyleVariantPicker ({ presentationType, chartLayout, value, onChange, variantParams, onParamsChange }) {
  const options = useMemo(() => {
    if (chartLayout) return getChartVariantOptions(chartLayout)
    return getVariantOptions(presentationType)
  }, [presentationType, chartLayout])

  const selected = options.find(o => o.value === value) ?? options[0]

  const parameters = useMemo(() => {
    const code = value || 'default'
    if (chartLayout) return getChartVariantParameters(chartLayout, code)
    return getVariantParameters(presentationType, code)
  }, [presentationType, chartLayout, value])

  return (
    <>
      <Grid item xs={12} md={6}>
        <SydLabel label='Style Variant' helperText={selected?.description}>
          <SydSelect
            options={options}
            value={value || 'default'}
            onChange={(e) => onChange(e.target.value)}
          />
        </SydLabel>
      </Grid>
      {parameters.length > 0 && onParamsChange
        ? (
          <VariantParamControls
            parameters={parameters}
            values={variantParams}
            onChange={onParamsChange}
          />
        )
        : null}
    </>
  )
}

StyleVariantPicker.propTypes = {
  presentationType: PropTypes.string,
  chartLayout: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variantParams: PropTypes.object,
  onParamsChange: PropTypes.func
}

export default StyleVariantPicker
